import React from 'react'
import NappiesOne from '../assets/images/Tile_Nappy-1.svg'
import NappiesTwo from '../assets/images/Tile_Nappy-2.svg'
import NappiesThree from '../assets/images/Tile_Nappy-3.svg'

const NappiesCards = () => {
  return (
    <div className="d-flex w-100 gap-4" style={{ padding: "0 0 15px 0" }}>
      <img src={NappiesOne} alt='nappieoneimage' />
      <img src={NappiesTwo} alt='nappietwoimage' />
      <img src={NappiesThree} alt='nappiethreeimage' />
  </div>
  )
}

export default NappiesCards